import { Box, Flex, Menu, Text } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type SuggestionDropdownProps = {
  label: string;
  bgColor: string;
  suggestions: Array<{
    key: string;
    textContent: string;
    scrollIntoView: () => void;
  }>;
};

export default function SuggestionDropdown({
  label,
  bgColor,
  suggestions,
}: SuggestionDropdownProps) {
  return (
    <Menu>
      <Menu.Target>
        <Flex
          bg="white"
          h={28}
          py="xxxs"
          px="xxs"
          style={{ borderRadius: 'var(--mantine-radius-xl)', cursor: 'pointer' }}
          align="center"
          gap="xxxs"
        >
          <Box p="xxxs">
            <Box h={12} w={12} bg={bgColor} style={{ borderRadius: '50%' }} />
          </Box>
          <Text size="sm" fw={FONT_WEIGHTS.medium} c="black" style={{ whiteSpace: 'nowrap' }}>
            {label}
          </Text>
          <IconChevronDown size={16} color="black" />
        </Flex>
      </Menu.Target>
      <Menu.Dropdown>
        {suggestions.length === 0 ? (
          <Menu.Item disabled>No suggestions</Menu.Item>
        ) : (
          suggestions.map(suggestion => (
            <Menu.Item key={suggestion.key} onClick={() => suggestion.scrollIntoView()}>
              <Text size="sm" fw={FONT_WEIGHTS.medium} c="black">
                {suggestion.textContent}
              </Text>
            </Menu.Item>
          ))
        )}
      </Menu.Dropdown>
    </Menu>
  );
}
